import React from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import TopBar from './site/TopBar';
import SiteDrawer from './site/SiteDrawer';

const theme = createMuiTheme();

function withRoot(name, Component) {
    function WithRoot(props) {
        return (
            <MuiThemeProvider theme={theme}>
                <CssBaseline />
                <TopBar title={name} />
                <SiteDrawer match={props.match} />
                
                <div className="content">
                    <Component {...props} />
                </div>
            </MuiThemeProvider>
        );
    }

    return WithRoot;
}

export default withRoot;


// WEBPACK FOOTER //
// ./src/withRoot.js